import axios from 'axios';

export default {
    namespaced: true,

    state: {
        wtaSystem: {},
        loadingWtaSystem: false,
        loadingWtaSystemError: null,
    },

    getters: {
        wtaSystem: (state) => state.wtaSystem,
        loadingWtaSystem: (state) => state.loadingWtaSystem,
        loadingWtaSystemError: (state) => state.loadingWtaSystemError,
    },

    mutations: {
        setWtaSystem(state, data) {
            state.wtaSystem = data;
        },
        clearWtaSystem(state) {
            state.wtaSystem = {};
        },
        startLoading(state) {
            state.loadingWtaSystem = true;
        },
        stopLoading(state) {
            state.loadingWtaSystem = false;
        },
        setLoadingError(state, error) {
            state.loadingWtaSystemError = error;
        },
        clearLoadingError(state) {
            state.loadingWtaSystemError = null;
        },
    },

    actions: {
        async retrieveWtaSystem(context) {
            context.commit('startLoading');
            context.commit('clearLoadingError');
            try {
                var result = await axios.get(`${HOST_NAME}/api/WtaSystem`);
                context.commit('setWtaSystem', result.data);
                context.commit('stopLoading');
                return Promise.resolve(result.data);
            } catch (error) {
                context.commit('setLoadingError', error);
                context.commit('stopLoading');
                return Promise.reject(error);
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/wta-system.js